type SelectOptionProps = { optionValue: string | undefined }

const SelectOption = ({ optionValue }: SelectOptionProps) => {
  return <option value={optionValue}>{optionValue}</option>
}

export default SelectOption
